<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">仓库</div>
                    <el-select
                        v-model="searchData.SId"
                        :loading="loading"
                        class="search-item"
                        size="small"
                        filterable
                        clearable
                        remote
                        @visible-change="warehouseVisibleChange($event)"
                    >
                        <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span></el-option
                        >
                    </el-select>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                </div>
                <div class="search-ctn-right" v-if="summaryStr">
                <div class="section-summary">
                    <div>
                        <span>{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'SaleTotalAmount', order: 'descending' }"
                    @sort-change="sortChange"
                >
                    <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="APCode" label="汽配编码"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="GoodName" label="汽配名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="GoodCode" label="互换码"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="AutoSerise" label="适用车型"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="Brand" label="品牌"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100" prop="APCate" label="分类"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" sortable="custom" prop="Count" label="原有库存"></el-table-column>
                    <el-table-column show-overflow-tooltip width="110" sortable="custom" prop="FiledCount" label="归档数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" width="110" prop="TotalCount" label="盈亏数">
                        <template slot-scope="scope">
                            <i v-if="scope.row.TotalCount < 0" class="out-active">{{
                                scope.row.TotalCount }}</i>
                            <i v-else-if="scope.row.TotalCount > 0" class="inven-active">{{
                                scope.row.TotalCount }}</i>
                            <i v-else>{{ scope.row.TotalCount }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="120" sortable="custom" prop="CostPrice" label="当前成本价"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable="custom" width="130" prop="TotalCost" label="盈亏总成本">
                        <template slot-scope="scope">
                            <i v-if="scope.row.TotalCost < 0" class="out-active">{{
                                scope.row.TotalCost }}</i>
                            <i v-else-if="scope.row.TotalCost > 0" class="inven-active">{{
                                scope.row.TotalCost }}</i>
                            <i v-else>{{ scope.row.TotalCost }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="85px">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="查看盘点明细" size="mini" type="text" @click="showInvenDatas(scope.row)">盘点数据</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.Page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.Limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        <el-dialog
            :close-on-click-modal="false"
            title="盘点统计搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-page-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="75px">
                    <el-form-item label="汽配编码">
                        <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="汽配编码"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入配件名称"
                            :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.AutoSerise"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入车型"
                            :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="盘点人">
                        <el-select v-model="searchData.StaffId" size="small" style="width: 100%" filterable placeholder="请选择" clearable>
                            <el-option v-for="item in sIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="盈亏数"><div class="flex">
                    <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="> < =">
                        <el-option key=">=" label=">=" value=">="></el-option>
                        <el-option key=">" label=">" value=">"></el-option>
                        <el-option key="<=" label="<=" value="<="></el-option>
                        <el-option key="<" label="<" value="<"></el-option>
                        <el-option key="=" label="=" value="="></el-option>
                        <el-option key="!=" label="!=" value="!="></el-option>
                        <el-option key="between" label="区间" value="between"></el-option>
                    </el-select>
                    <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent1"></el-input>
                    <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent2" v-if="searchData.Symbol == 'between'"></el-input>
                    </div>
                    </el-form-item>
                    <el-form-item label="归档时间">
                        <el-date-picker class="search-item" style="width: 100%" v-model="dateTimes" size="small" :picker-options="pickerOptions" @change="onDateTimeSelect" type="daterange" placeholder="选择时间"></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="盘点商品明细" :visible.sync="detailsVisible" width="1300px">
            <div class="dialog-content" v-if="detailsVisible">
                <invenDatas ref="invenGoodsDetails" :GoodsId="goodsId"></invenDatas>
            </div>
        </el-dialog>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import invenDatas from '@/components/business/goods/invenGoodsDetails';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'inventoryStat',
    components: {
        breadcrumb,
        invenDatas
    },
    data() {
        return {
            dateTimes: [],
            loading: false,
            detailsVisible: false,
            goodsId:false,
            brand: [],
            typeList: [],
            summaryStr:'',
            searchData: {
                Symbol: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                StaffId: '',
                Invent1: 0,
                Invent2: 0,
                Page: 1,
                Limit: 15
            },
            dialogVisible: false,
            goodsCategories: [],
            tableData: [],
            tableDataLength: 0,
            warehouseList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            sIdList:[]
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        let that = this;
        document.addEventListener('keydown', that.handleKeyEvent);
     
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        that.dateTimes.push(date1);

        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        that.dateTimes.unshift(date2);

        that.searchData.StartDate = date2;
        that.searchData.EndDate = date1;
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                e.preventDefault();
                if (that.sIdList.length <= 1) that.getSIdList();
                that.dialogVisible = true;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogVisible) that.dialogVisible = false;
            }
            if (key === 13) {
                e.preventDefault();
                that.handleSearch();
                return;
            }
            //左键
            if (key == 37) {
                e.preventDefault();
                if (this.searchData.Page > 1) {
                    this.searchData.Page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                e.preventDefault();
                if (this.searchData.Page < Math.ceil(this.tableDataLength / this.searchData.Limit)) {
                    this.searchData.Page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        searchGoodsType() {
            this.$util
                .searchGoodsType()
                .then(data => {
                    if (!data) return;
                    this.typeList = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                Symbol: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                StaffId: '',
                Invent1: 0,
                Invent2: 0,
                Page: 1,
                Limit: this.commonPageSize
            };
            this.dateTimes = [];
        },
        // 获取数据
        getTableData() {
            let that = this;
            if (that.searchData.Symbol) {
                if (that.searchData.Symbol == 'between') {
                    if (isNaN(that.searchData.Invent1)) {
                        that.$util.warningMsg('请输入正确的盈亏数');
                        return;
                    }
                    if (isNaN(that.searchData.Invent2)) {
                        that.$util.warningMsg('请输入正确的盈亏数');
                        return;
                    }
                } else {
                    if (isNaN(that.searchData.Invent1)) {
                        that.$util.warningMsg('请输入正确的盈亏数');
                        return;
                    }
                }
            }
            that.$util
                .axiosPost({
                    url: '/api/DataStatistics/InvenPAndLStatData',
                    data: that.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (res.errcode != 201) {
                        if (!data) {
                            that.tableData = [];
                            if (that.searchData.Page == 1) {
                                that.summaryStr = '';
                            }
                            return;
                        } else {
                            if (that.searchData.Page == 1) {
                                that.summaryStr = data.SummaryStr;
                            }
                            that.tableData = data.DataList;
                            that.tableDataLength = res.count;
                        }
                    }
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.Page = 1;
            this.getTableData();
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.Page - 1) * this.searchData.Limit;
        },
        getWarehouse() {
            this.$util.getWarehouse().then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            if (this.sIdList.length <= 1) this.getSIdList();
            this.dialogVisible = true;
        },
        //选中时间
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = "";
                this.searchData.EndDate = "";
            }
        },
        getSIdList() {
            this.$util.getCommonSIdList().then((data) => {
                this.sIdList = data;
            });
        },
        showInvenDatas(row){
            if(row.Id){
                this.goodsId = row.Id;
                this.detailsVisible = true;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }

        .el-button {
            padding: 0;
        }
    }
}
.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .image-sup {
        width: 22px;
        height: 22px;
        margin-right: 10px;
    }
    .image-cus {
        width: 22px;
        height: 22px;
    }
}
</style>
